import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//components
import { HomePageComponent } from './home-page/home-page.component';

//routing
import { HomeRoutingModule } from './home-routing.module';

//modules
import { SharedModule } from 'src/app/shared/shared.module';
import { DashboardModule } from '../dashboards/dashboard.module';

@NgModule({
  declarations: [HomePageComponent],
  imports: [CommonModule, HomeRoutingModule, SharedModule,DashboardModule],
})
export class HomeModule {}
